import * as React from 'react';
import omit from 'rc-util/lib/omit';
import classNames from 'classnames';
import Element from './Element';
import { ConfigContext } from '../config-provider';
const SkeletonInput = (props) => {
    const { prefixCls: customizePrefixCls, className, active, block } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const otherProps = omit(props, ['prefixCls']);
    const cls = classNames(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block,
    }, className);
    return (<div className={cls}>
      <Element prefixCls={`${prefixCls}-input`} {...otherProps}/>
    </div>);
};
SkeletonInput.defaultProps = {
    size: 'default',
};
export default SkeletonInput;
